import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'cash-allocation',
  template: require('./cash-allocation.component.html'),
  styles: [require('./cash-allocation.component.scss')]
})
export class CashAllocationComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }
  updateOptionValue(event) {
    if (event.value) {
      const isCashVested = event.value === 'cashEnhanced';
      this.appActions.setData('goalSession.isCashVested', isCashVested);
    }
  }
}
